/**
 * Étendues sur lesquelles un effort peut se noter : de la note la plus basse à la plus haute.
 *
 * La valeur est ce qui s'affiche : deux nombres séparés d'un trait se lisent dans toutes les
 * langues, il n'y a rien à traduire. Les crans se déduisent de l'une et l'autre borne.
 *
 * Elles ne valent que d'un effort noté en nombres. En toutes lettres, l'échelle ne se dit plus par
 * ses bornes mais par ses libellés (cf. `CES_TEXT_REPRESENTATION`) : ses cinq encadrés sont les
 * mêmes quelle que soit l'étendue chiffrée, qui reste en place et reprend dès le retour aux nombres.
 */
export enum CES_RANGE {
    ONE_TO_FIVE = '1-5',
    ONE_TO_SEVEN = '1-7',
    ZERO_TO_TEN = '0-10',
}
